module.exports = __webpack_public_path__ + "img/logs-empty-plug.7f206e1a.svg";